var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{ref:"logAs",staticClass:"mb-0 fixed-top log-as",attrs:{"id":"log-as","show":_vm.isLoggedAs,"dismissible":"","variant":"info"},on:{"dismissed":_vm.existLogAs}},[_vm._v("\n  You are connected as "),_c('strong',[_vm._v(_vm._s(this.$store.getters["auth/fullName"])+" ("+_vm._s(this.$store.getters["auth/role"])+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }